// generated by Copilot and not reviewed line by line

package com.huanshankeji.compose.material.icons.filled

import com.huanshankeji.compose.material.icons.Icon
import com.huanshankeji.compose.material.icons.Icons

actual val Icons.Filled.AccountBox: Icon get() = Icon("account_box")
actual val Icons.Filled.AccountCircle: Icon get() = Icon("account_circle")
actual val Icons.Filled.Add: Icon get() = Icon("add")
actual val Icons.Filled.AddCircle: Icon get() = Icon("add_circle")
actual val Icons.Filled.ArrowBack: Icon get() = Icon("arrow_back")
actual val Icons.Filled.ArrowDropDown: Icon get() = Icon("arrow_drop_down")
actual val Icons.Filled.ArrowForward: Icon get() = Icon("arrow_forward")
actual val Icons.Filled.Build: Icon get() = Icon("build")
actual val Icons.Filled.Call: Icon get() = Icon("call")
actual val Icons.Filled.Check: Icon get() = Icon("check")
actual val Icons.Filled.CheckCircle: Icon get() = Icon("check_circle")
actual val Icons.Filled.Close: Icon get() = Icon("close")
actual val Icons.Filled.DateRange: Icon get() = Icon("date_range")
actual val Icons.Filled.Delete: Icon get() = Icon("delete")
actual val Icons.Filled.Done: Icon get() = Icon("done")
actual val Icons.Filled.Edit: Icon get() = Icon("edit")
actual val Icons.Filled.ExitToApp: Icon get() = Icon("exit_to_app")
actual val Icons.Filled.Face: Icon get() = Icon("face")
actual val Icons.Filled.Favorite: Icon get() = Icon("favorite")
actual val Icons.Filled.Home: Icon get() = Icon("home")
actual val Icons.Filled.Info: Icon get() = Icon("info")
actual val Icons.Filled.KeyboardArrowDown: Icon get() = Icon("keyboard_arrow_down")
actual val Icons.Filled.KeyboardArrowLeft: Icon get() = Icon("keyboard_arrow_left")
actual val Icons.Filled.KeyboardArrowRight: Icon get() = Icon("keyboard_arrow_right")
actual val Icons.Filled.KeyboardArrowUp: Icon get() = Icon("keyboard_arrow_up")
actual val Icons.Filled.List: Icon get() = Icon("list")
actual val Icons.Filled.Lock: Icon get() = Icon("lock")
actual val Icons.Filled.Menu: Icon get() = Icon("menu")
actual val Icons.Filled.MoreVert: Icon get() = Icon("more_vert")
actual val Icons.Filled.Notifications: Icon get() = Icon("notifications")
actual val Icons.Filled.Person: Icon get() = Icon("person")
actual val Icons.Filled.Place: Icon get() = Icon("place")
actual val Icons.Filled.PlayArrow: Icon get() = Icon("play_arrow")
actual val Icons.Filled.Refresh: Icon get() = Icon("refresh")
actual val Icons.Filled.Search: Icon get() = Icon("search")
actual val Icons.Filled.Send: Icon get() = Icon("send")
actual val Icons.Filled.Settings: Icon get() = Icon("settings")
actual val Icons.Filled.Share: Icon get() = Icon("share")
actual val Icons.Filled.ShoppingCart: Icon get() = Icon("shopping_cart")
actual val Icons.Filled.Star: Icon get() = Icon("star")
actual val Icons.Filled.ThumbUp: Icon get() = Icon("thumb_up")
actual val Icons.Filled.Warning: Icon get() = Icon("warning")
